import React, { useState } from 'react';
import {
  Box,
  Paper,
  Typography,
  TextField,
  Button,
  Alert,
  Container,
  InputAdornment,
  IconButton
} from '@mui/material';
import {
  Email,
  Lock,
  Visibility,
  VisibilityOff,
  AdminPanelSettings
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { auth, db } from '../../services/firebase';
import { motion } from 'framer-motion';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { collection, query, where, getDocs } from 'firebase/firestore';

const MotionPaper = motion(Paper);

function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      // Admin girişi kontrolü
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      // Admin kontrolü
      const adminUsersRef = collection(db, 'adminUsers');
      const q = query(adminUsersRef, where('uid', '==', user.uid));
      const querySnapshot = await getDocs(q);

      if (querySnapshot.empty) {
        throw new Error('Admin yetkisi bulunamadı');
      }

      // Admin bilgilerini kaydet
      const adminData = querySnapshot.docs[0].data();
      localStorage.setItem('adminUser', JSON.stringify({
        uid: user.uid,
        email: user.email,
        ...adminData
      }));

      // Admin paneline yönlendir
      navigate('/admin');

    } catch (error) {
      console.error('Admin giriş hatası:', error);
      let errorMessage = 'Giriş yapılırken bir hata oluştu';
      
      if (error.message === 'Admin yetkisi bulunamadı') {
        errorMessage = 'Bu hesap admin yetkisine sahip değil';
      } else {
        switch (error.code) {
          case 'auth/invalid-credential':
            errorMessage = 'Email veya şifre hatalı';
            break;
          case 'auth/user-not-found':
            errorMessage = 'Kullanıcı bulunamadı';
            break;
          case 'auth/wrong-password':
            errorMessage = 'Şifre hatalı';
            break;
          default:
            errorMessage = error.message;
        }
      }
      
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 8 }}>
        <MotionPaper
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.5 }}
          elevation={3}
          sx={{ p: 4, borderRadius: 2 }}
        >
          <Box sx={{ textAlign: 'center', mb: 4 }}>
            <AdminPanelSettings sx={{ fontSize: 60, color: 'primary.main', mb: 2 }} />
            <Typography variant="h4" gutterBottom sx={{ fontWeight: 600 }}>
              Admin Girişi
            </Typography>
            <Typography color="text.secondary">
              Yönetici paneline erişmek için giriş yapın
            </Typography>
          </Box>

          {error && (
            <Alert severity="error" sx={{ mb: 3 }}>
              {error}
            </Alert>
          )}

          <form onSubmit={handleSubmit}>
            <TextField
              fullWidth
              label="E-posta"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              margin="normal"
              required
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Email sx={{ color: 'primary.main' }} />
                  </InputAdornment>
                ),
              }}
            />

            <TextField
              fullWidth
              label="Şifre"
              type={showPassword ? 'text' : 'password'}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              margin="normal"
              required
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Lock sx={{ color: 'primary.main' }} />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowPassword(!showPassword)}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              disabled={loading}
              sx={{
                mt: 3,
                mb: 2,
                height: 56,
                background: 'linear-gradient(45deg, #00bf0d 30%, #4cf13d 90%)',
                boxShadow: '0 3px 5px 2px rgba(0, 191, 13, .3)',
                '&:hover': {
                  background: 'linear-gradient(45deg, #00bf0d 60%, #4cf13d 90%)',
                  boxShadow: '0 4px 10px 2px rgba(0, 191, 13, .4)',
                }
              }}
            >
              {loading ? 'Giriş Yapılıyor...' : 'Giriş Yap'}
            </Button>
          </form>
        </MotionPaper>
      </Box>
    </Container>
  );
}

export default AdminLogin; 